export function isHidden(node) {
    if (window.getComputedStyle(node).visibility === 'hidden') {
        return true;
    }
    var parent = node;
    while (parent) {
        if (window.getComputedStyle(parent).display === 'none') {
            return true;
        }
        parent = parent.parentElement;
    }
    return false;
}
